import React from "react";
import TableRow from "./TableRow";
import TableHeadItem from "./TableHeadItem";
import TableFooter from "./TableFooter";
import "./ServicesTable.scss";

const ServicesTable = ({ theadData, tbodyData,tfooterData, customClass }) => {
    return (
        <div className="table-block">
            <table className={customClass}>
            {theadData?.length > 0 && 
                <thead>
                    <tr className="table-heading">
                        {theadData.map((h,i) => {
                            return <TableHeadItem key={i} item={h} />;
                        })}
                    </tr>
                </thead>
            }
            {tbodyData?.length > 0 && 
                <tbody>
                    {tbodyData.map((item,i) => {
                        if(item.items.length > 0){
                            return <TableRow key={i} data={item.items} />
                        }
                    })}
                </tbody>
            }

            {tfooterData?.length > 0 && 
                <tfoot>
                    <tr>
                    {tfooterData.map((p,i) => {
                        if(p){
                            return <TableFooter key={i} item={p} />;
                        }                
                    })}
                    </tr>
                </tfoot>
            }
        </table>
        </div>
    );
};

export default ServicesTable;